import React from 'react'
import Layout from '../components/Layout'
import Hero from '../components/Hero'
import { graphql } from 'gatsby'
import PostsAll from '../components/PostsAll'
import { Helmet } from 'react-helmet'

const PostsPage = ({ data }) => {
  const {
    allMdx: { nodes: posts },
  } = data

  const APP_NAME = 'DevsrcBlog'

  return (
    <React.Fragment>
      <Helmet>
        <title>All Posts | {APP_NAME}</title>
        <meta
          name="description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <link
          rel="canonical"
          href="https://mdx-blog-testing-mode.netlify.app/posts"
        />
        <meta
          property="og:title"
          content={`Latest web developoment tutorials | ${APP_NAME}`}
        />
        <meta
          property="og:description"
          content="Programming blogs and tutorials on react node next vue php laravel and web developoment"
        />
        <meta property="og:type" content="webiste" />
        <meta
          property="og:url"
          content="https://mdx-blog-testing-mode.netlify.app/posts"
        />
        <meta property="og:site_name" content={`${APP_NAME}`} />

        <meta
          property="og:image"
          content={`https://mdx-blog-testing-mode.netlify.app/posts/static/mainImg.png`}
        />
        <meta
          property="og:image:secure_url"
          content={`https://mdx-blog-testing-mode.netlify.app/posts/mainImg.png`}
        />
        <meta property="og:image:type" content="image/jpg" />
      </Helmet>

      <Layout>
        <Hero showPersonPost />
        <PostsAll posts={posts} title="all posts" />
      </Layout>
    </React.Fragment>
  )
}

export const query = graphql`
  {
    allMdx(sort: { fields: frontmatter___date, order: DESC }) {
      nodes {
        excerpt
        frontmatter {
          title
          author
          category
          readTime
          date(formatString: "MMMM, Do YYYY")
          slug
          image {
            childImageSharp {
              gatsbyImageData
            }
          }
        }
        id
      }
    }
  }
`

export default PostsPage
